import React, { useEffect, useState } from "react";
import { ReactComponent as CopyIcon } from "../../../assets/Icons/copy.svg";
import { ReactComponent as TickIcon } from "../../../assets/Icons/tick.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchGiftHistory } from "./service";
import Translate, { useTranslateText } from "../../../Components/Multilanguage/Translate";

const GiftDetails = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const [giftHistory, setGiftHistory] = useState({});
  const [copiedIndex, setCopiedIndex] = useState(null);
  const translateText = useTranslateText();

  const navigate = useNavigate();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(() => {
    window.scroll(0, 0);
    getGiftHistory();
  }, []);

  const handleCopy = (code, idx) => {
    if (code) {
      const url = `${window.location.origin}/gift/claim?gc=${code}`;
      navigator.clipboard.writeText(url);
      setCopiedIndex(idx);
      setTimeout(() => setCopiedIndex(null), 1600);
    }
  };

  const getGiftHistory = async () => {
    try {
      const response = await fetchGiftHistory(appInfo);
      if (response?.status === 200) {
        setGiftHistory(response?.data);
      }
    } catch (err) {}
  };

  return (
    <div className="billingAndSubscription">
      <div className="wrapper">
        <div className="billingDetails">
          <h1 className="heading">
            <Translate textKey={"gift_details"} />
          </h1>
          <div className="detailsSection">
            <ul className="subscriptionContainer">
              <li className="head">
                <div className="left">
                  <div className="date">
                    <Translate textKey={"gift"} />
                  </div>
                  <div className="transactionType">
                    <Translate textKey={"status"} />
                  </div>
                  <div className="servicePeriod">
                    <Translate textKey={"purchased_by"} />
                  </div>
                  <div className="paymentMethod">
                    <Translate textKey={"recipient"} />
                  </div>
                  <div className="subscriptionName">
                    <Translate textKey={"redemption_date"} />
                  </div>
                  <div className="subscriptionName">
                    <Translate textKey={"purchase_date"} />
                  </div>
                </div>
                <div className="right">
                  <div className="total">
                    <Translate textKey={"code"} />
                  </div>
                </div>
              </li>
              {giftHistory?.data && giftHistory.data.length > 0 ? (
                giftHistory.data.map((item, index) => (
                  <li key={index} className="body">
                    <div className="left">
                      <div className="date">
                        <div>
                          {item?.period} x {item?.plan_name}
                        </div>
                      </div>
                      <div className="transactionType">{item?.status}</div>
                      <div className="servicePeriod">{item?.buyer_info}</div>
                      <div className="paymentMethod">
                        {item?.recipient_info || "-"}
                      </div>
                      <div className="subscriptionName">
                        {item?.redeemed_date
                          ? new Date(item.redeemed_date).toLocaleDateString()
                          : "-"}
                      </div>
                      <div className="subscriptionName">
                        {item?.purchase_date
                          ? new Date(item.purchase_date).toLocaleDateString()
                          : "-"}
                      </div>
                    </div>
                    <div className="right">
                      <div className="total" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <span>{item?.giftcode}</span>
                        {item?.status !== 'REDEEMED' && item?.giftcode && (
                          <button
                            className={`copyGiftCodeBtn${copiedIndex === index ? ' copied' : ''}`}
                            onClick={() => handleCopy(item.giftcode, index)}
                            title={copiedIndex === index ? translateText('copied') : 'Copy claim URL'}
                            aria-label="Copy claim URL"
                            type="button"
                            style={{ marginLeft: 8 }}
                          >
                            <span className="icon-wrapper" style={{ position: 'relative', width: 20, height: 20, display: 'inline-block' }}>
                              <CopyIcon width={18} height={18} className={copiedIndex === index ? 'icon-hide' : 'icon-show'} style={{ position: 'absolute', left: 0, top: 0 }} />
                              <TickIcon width={18} height={18} className={copiedIndex === index ? 'icon-show' : 'icon-hide'} style={{ position: 'absolute', left: 0, top: 0 }} />
                            </span>
                          </button>
                        )}
                      </div>
                    </div>
                  </li>
                ))
              ) : (
                <li className="body">
                  <div style={{ width: "100%", textAlign: "center", color: "red", padding: "40px 0" }}>
                    <Translate textKey="no_data_found" />
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="bottom">
          <div className="gift-buttons">
            <button onClick={() => navigate("/gift/purchase")}> <Translate textKey="purchase_gift_card" /> </button>
            <button onClick={() => navigate("/gift/claim")}> <Translate textKey="claim_gift_card" /> </button>
          </div>
          <div className="buttonContainer" onClick={() => navigate("/account")}> <div className="background" /> <button><Translate textKey={"back"} /></button> </div>
        </div>
      </div>
    </div>
  );
};

export default GiftDetails;
